/**
 * Created by Mark on 18/04/2017.
 */

import React  from 'react';
import Step from './wizard-step.js';
import {Nav} from 'react-bootstrap';
import Translation from  '../../store/internationalization-store.js';


const  clone = function (obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;

}

export default class Wizard extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state ={currentStep:0, data:this.props.data ? clone(this.props.data) : {}}
        this.modifiyWizard = this.props.onModify || function() {};
    }

    componentWillReceiveProps(props){

      /*  var newProps = props.data ? clone(props.data) : {};
        var oldProps = clone(this.state.data) || {};

        console.log(props);
        for(var key in newProps){
            if(newProps.hasOwnProperty(key)) oldProps[key] = newProps[key];
        }

        console.log(oldProps);

        this.setState({data:clone(oldProps)});*/
    }


    reset(){
        this.setState({
            currentStep:0
        })
    }

    render(){

        //bullseye
        const self = this;
        const step =  this.props.steps[this.state.currentStep];
        console.log(this.props.steps);
        /*let items = this.props.steps.map((item, i) => (
            <div key={"wizard-step-"+i} class="wiz-step">
                <div className="wiz-step-inner">
                    <div className={ 'wiz-step-circle ' + (this.state.currentStep === i ? 'active' : this.state.currentStep > i ? 'is-done' : '') } >
                        <span><i className={this.state.currentStep > i? "fa fa-fw fa-check" : "hide"}></i><b className={this.state.currentStep > i? "hide" : "show"}>{i + 1}</b></span>
                    </div>
                </div>
            </div>
        ));*/
        var useNames = false;
        if (this.props.names != undefined && this.props.steps.length == this.props.names.length) {
            useNames = true;
        }
        var getName = function(item, i) {
            if (useNames == true) {
                return this.props.names[i];
            } else {
                return item.name();
            }
        }.bind(this)
        let items = this.props.steps.map((item, i) => (
            <Nav.Item >
                <Nav.Link className={(this.state.currentStep === i ? 'active' : this.state.currentStep > i ? 'is-done' : 'disabled')} eventKey={this.state.currentStep === i ? 'active' : this.state.currentStep > i ? 'is-done' : ''} >
                    <center> {item.icon}</center>
                    <center style={{marginTop:"5px"}}><strong>{Translation.get(12775 , 'Step')} &nbsp;{(i+1)}</strong></center>
                    {getName(item, i)}
                </Nav.Link>
            </Nav.Item>
        ));


        const Component = React.createElement(Step, {
            key: 'step' + this.state.currentStep,
            onSubmit: step.onSubmit,
            onModify:this.modifiyWizard,
            onBack: step.onBack,
            reset:function(){
                self.setState({
                    currentError: null,
                    currentStep: 0
                });
            },
            onAdvance: function(){
                self.setState({
                    currentError: null,
                    currentStep: self.state.currentStep+1
                });
            },
            onRetreat: function(){
                self.setState({
                    currentError: null,
                    currentStep: self.state.currentStep-1
                });
            },
            handelError: step.handelError || false,
            component: step.component,
            data: this.state.data,
            information:this.props.information,
            navigationTop:step.navigationTop,
            firstStep: this.state.currentStep === 0,
            lastStep:  this.state.currentStep === this.props.steps.length-1,
            disableButtons:step.disableButtons,
        });
        const  title = step.title ? <h2 className="m-t-20">{step.title}<small className="float-right">{step.description}</small></h2> : null;


        return <div style={{padding:"10px"}} >


                    <div className="wizard_splitter">
                        <div className="nav nav-pills nav-justified thumbnail">
                            {items}
                        </div>
                    </div>

                    <div style={{paddingTop:"20px"}}>
                    {Component}
                    </div>



            </div>;
    }

}

